module.exports = __webpack_public_path__ + "img/qrcode-scaned.77bc73a5.png";